import {
    Component,
    OnInit
} from '@angular/core'

import { AlertService } from '../shared/alert.service'
import { Alert } from '../shared/alert.model'

@Component({
    selector: 'col-alert-container',
    templateUrl: './alert-container.component.html',
    styleUrls: ['./alert-container.component.scss']
})
export class AlertContainerComponent implements OnInit {
    alerts: Alert[]

    constructor(private service: AlertService) {
        this.alerts = service.alerts
    }

    ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/common/alert/alert-container/alert-container.component.ts